import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../dialogs/Dialog';
import ManualPDF from './ManualPDF';

/**
 * Manual dialog list
 * @module
 * @param {bool} isOpenManualDialogList - Is manual dialog list open?
 * @param {func} handleClose - Handle close function
 * @param {string} manualTitle - Manual Title
 * @param {manualProps} manualProps - Props for manual
 * @param {func} getManual - Function to get manual
 */
const ManualDialogList = (props) => {
  const [isOpenManualDialogPDF, setIsOpenManualDialogPDF] = useState(false);
  const [titlePDF, setTitlePDF] = useState('');

  const handleOpenPDF = async (ID, N_TITLE) => {
    await props.getManual(ID);
    setIsOpenManualDialogPDF(true);
    setTitlePDF(N_TITLE);
  };

  const handleCloseList = () => {
    props.handleClose();
  };

  const handleClosePDF = () => {
    setIsOpenManualDialogPDF(false);
  };

  const buildManualList = () => {
    const { manualProps } = props;
    const { manualListDataMap, manualListData } = manualProps;

    return (
      <div>
        {manualListData.map((item) => {
          return (
            <div key={item[manualListDataMap.key]} className="popis" onClick={() => handleOpenPDF(item[manualListDataMap.key], item.N_TITLE)}>
              <span>{item[manualListDataMap.title]}</span><span className="popis-datum">{item.D_DATUM_UPR}</span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Dialog
        isOpen={props.isOpenManualDialogList}
        onClose={handleCloseList}
        fullscreen={true}
        title={props.manualTitle}
      >
        {buildManualList()}
      </Dialog>
      <ManualPDF
        extraDialog={true}
        manualProps={props.manualProps}
        handleClosePDF={handleClosePDF}
        isOpenManualDialogPDF={isOpenManualDialogPDF}
        getManual={props.getManual}
        manualTitle={props.manualTitle}
        getListManual={props.getListManual}
        titlePDF={titlePDF}
      />
    </>
  )
}

ManualDialogList.propTypes = {
  getManual: PropTypes.func.isRequired,
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    listManual: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualList: PropTypes.arrayOf(PropTypes.object),
    manualListData: PropTypes.array,
    manualListDataMap: PropTypes.object
  }).isRequired,
  isOpenManualDialogList: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  manualTitle: PropTypes.string.isRequired,
}

export default ManualDialogList;